import { RouteFactory } from "@app/routePaths";
import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render SBA awards page
 */
const SBAAwardsPage = (): React.ReactElement => {
  const linkClassName = "mb-2 underline font-bold cursor-pointer";

  return (
    <div
      className="mb-10 font-public-sans"
      data-testid="sba-awards-page-component"
    >
      <BlockTitle
        text="Awards"
        rootClassName="text-4xl md:text-6xl lg:text-8xl font-medium mb-6"
      />

      <div className="flex flex-row">
        <ul className="flex-1 list-outside list-disc pl-8 pr-6">
          <li className={linkClassName}>
            <a
              href={RouteFactory.sbaAwards("businessman-of-the-year")}
              target="_blank"
              rel="noreferrer"
            >
              Businessman Of The Year
            </a>
          </li>

          <li className={linkClassName}>
            <a
              href={RouteFactory.sbaAwards(
                "outstanding-chief-executive-of-the-year"
              )}
              target="_blank"
              rel="noreferrer"
            >
              Outstanding Chief Executive Of The Year
            </a>
          </li>

          <li className={linkClassName}>
            <a
              href={RouteFactory.sbaAwards(
                "outstanding-overseas-executive-of-the-year"
              )}
              target="_blank"
              rel="noreferrer"
            >
              Outstanding Overseas Executive Of The Year
            </a>
          </li>
        </ul>

        <ul className="flex-1 list-outside list-disc pl-8">
          <li className={linkClassName}>
            <a
              href={RouteFactory.sbaAwards("the-enterprise-award")}
              target="_blank"
              rel="noreferrer"
            >
              The Enterprise Award
            </a>
          </li>

          <li className={linkClassName}>
            <a
              href={RouteFactory.sbaAwards("young-business-leader-of-the-year")}
              target="_blank"
              rel="noreferrer"
            >
              Young Business Leader Of The Year
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SBAAwardsPage;
